import { gql } from '@/__generated__/gql';

export const MANAGER_UPDATES_INVESTMENT_WORKFLOW_STATE_FILTERS_QUERY = gql(`
  query ManagerUpdatesInvestmentWorkflowStateFilters {
    InvestmentWorkflowStateFilters {
        id
        name
        label
        subjectStatus
      }
    }
  `);

export const PUBLISHED_INVESTMENT_MANAGER_UPDATES_INVESTMENT_IDS_QUERY = gql(`
  query ManagerUpdatesPagePublishedInvestmentManagerUpdatesInvestmentIds($data: PublishedInvestmentManagerUpdatesInputDto!) {
    publishedInvestmentManagerUpdates(data: $data) {
      investment {
        id
      }
    }
  }
`);

export const PUBLISHED_INVESTMENT_MANAGER_UPDATES_QUERY = gql(`
  query ManagerUpdatesPagePublishedInvestmentManagerUpdates($data: PublishedInvestmentManagerUpdatesInputDto!) {
    publishedInvestmentManagerUpdates(data: $data) {
      investment {
        id
        name
        assetClass {
          id
          name
        }
        subAssetClass {
          id
          name
        }
        pacingType
        pacingStartingYear
        description
      }
      legalEntityCommittedCapital {
        committedCapital
        entityName
      }
      publishedUpdates {
        documentFieldAnswer {
          id
          value
          commentary
          createdAt
          updatedAt
          deletedAt
          recordId
          fieldId
        }
        documentField {
          id
          name
          type
          order
          promptGroupId
          renderOrder
        }
      }
      lastUpdate
      sentimentFlag
      sentimentFlagLabel
    }
  }
`);

export const LIST_INVESTMENTS_FOR_MANAGER_UPDATE_QUERY = gql(`
  query ManagerUpdatesPageListInvestmentsForManagerUpdate(
    $page: Int!
    $rowsPerPage: Int!
    $managerUpdateFilter: [String!]
    $quickStatusFilter: String
    $sortBy: String
    $order: String
    $search: String
  ) {
    listInvestmentsForManagerUpdate(
      page: $page
      rowsPerPage: $rowsPerPage
      managerUpdateFilter: $managerUpdateFilter
      quickStatusFilter: $quickStatusFilter
      sortBy: $sortBy
      order: $order
      search: $search
    ) {
      total
      page
      perPage
      filters {
        name
        type
        value
        enabled
        count
      }
      data {
        id
        name
        managerId
        securityStatus
        documentRecordMetadata {
          last_mu_publish_date
          num_of_mu
          ids
          num_of_mu_draft
          num_of_mu_published
          new_ai_suggestions_date
          new_ai_suggestions_document_id
        }
        workflowInstance {
          currentState {
            name
            label
          }
        }
      }
    }
  }
`);

export const DOCUMENT_FIELD_RENDER_ORDER_QUERY = gql(`
  query ManagerUpdatesPageDocumentFieldRenderOrder {
    documentFieldRenderOrder {
      id
      name
      order
      promptGroupId
      renderOrder
      type
    }
  }
`);
